"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.resolvePageDimensions = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var _rpdfYoga = _interopRequireDefault(require("@surge-global-engineering/rpdf-yoga"));
var P = _interopRequireWildcard(require("@surge-global-engineering/rpdf-primitives"));
var _getMargin = _interopRequireDefault(require("../node/getMargin"));
var _getPadding = _interopRequireDefault(require("../node/getPadding"));
var _getPosition = _interopRequireDefault(require("../node/getPosition"));
var _getDimension = _interopRequireDefault(require("../node/getDimension"));
var _getBorderWidth = _interopRequireDefault(require("../node/getBorderWidth"));
var _getAbsolutePosition = _interopRequireDefault(require("../node/getAbsolutePosition"));
var _setDisplay = _interopRequireDefault(require("../node/setDisplay"));
var _setOverflow = _interopRequireDefault(require("../node/setOverflow"));
var _setFlexWrap = _interopRequireDefault(require("../node/setFlexWrap"));
var _setFlexGrow = _interopRequireDefault(require("../node/setFlexGrow"));
var _setFlexBasis = _interopRequireDefault(require("../node/setFlexBasis"));
var _setAlignSelf = _interopRequireDefault(require("../node/setAlignSelf"));
var _setAlignItems = _interopRequireDefault(require("../node/setAlignItems"));
var _setFlexShrink = _interopRequireDefault(require("../node/setFlexShrink"));
var _setAspectRatio = _interopRequireDefault(require("../node/setAspectRatio"));
var _setAlignContent = _interopRequireDefault(require("../node/setAlignContent"));
var _setPositionType = _interopRequireDefault(require("../node/setPositionType"));
var _setFlexDirection = _interopRequireDefault(require("../node/setFlexDirection"));
var _setJustifyContent = _interopRequireDefault(require("../node/setJustifyContent"));
var _setMargin = require("../node/setMargin");
var _setPadding = require("../node/setPadding");
var _setBorderWidth = require("../node/setBorderWidth");
var _setPosition = require("../node/setPosition");
var _setDimension = require("../node/setDimension");
var _measureSvg = _interopRequireDefault(require("../svg/measureSvg"));
var _measureText = _interopRequireDefault(require("../text/measureText"));
var _measureImage = _interopRequireDefault(require("../image/measureImage"));
var _measureCanvas = _interopRequireDefault(require("../canvas/measureCanvas"));
var _measureSpaceFillingView = _interopRequireDefault(require("../view/measureSpaceFillingView"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var YOGA_NODE = '_yogaNode';
var YOGA_CONFIG = _rpdfYoga.default.Config.create();
YOGA_CONFIG.setPointScaleFactor(0);
var isType = R.propEq('type');
var isSvg = isType(P.Svg);
var isText = isType(P.Text);
var isView = isType(P.View);
var isNote = isType(P.Note);
var isPage = isType(P.Page);
var isImage = isType(P.Image);
var isCanvas = isType(P.Canvas);
var isTextInstance = isType(P.TextInstance);
var setNodeHeight = function setNodeHeight(node) {
  return R.ifElse(isPage, (0, _setDimension.setHeight)(node.box.height), (0, _setDimension.setHeight)(node.box.height || node.style.height));
};

/**
 * Set styles valeus into yoga node before layout calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */
var setYogaValues = R.tap(function (node) {
  R.compose(setNodeHeight(node), (0, _setDimension.setWidth)(node.style.width), (0, _setDimension.setMinWidth)(node.style.minWidth), (0, _setDimension.setMaxWidth)(node.style.maxWidth), (0, _setDimension.setMinHeight)(node.style.minHeight), (0, _setDimension.setMaxHeight)(node.style.maxHeight), (0, _setMargin.setMarginTop)(node.style.marginTop), (0, _setMargin.setMarginRight)(node.style.marginRight || node.style.marginOutside), (0, _setMargin.setMarginBottom)(node.style.marginBottom), (0, _setMargin.setMarginLeft)(node.style.marginLeft || node.style.marginInside), (0, _setPadding.setPaddingTop)(node.style.paddingTop), (0, _setPadding.setPaddingRight)(node.style.paddingRight), (0, _setPadding.setPaddingBottom)(node.style.paddingBottom), (0, _setPadding.setPaddingLeft)(node.style.paddingLeft), (0, _setPositionType.default)(node.style.position), (0, _setPosition.setPositionTop)(node.style.top), (0, _setPosition.setPositionRight)(node.style.right), (0, _setPosition.setPositionBottom)(node.style.bottom), (0, _setPosition.setPositionLeft)(node.style.left), (0, _setBorderWidth.setBorderTop)(node.style.borderTopWidth), (0, _setBorderWidth.setBorderRight)(node.style.borderRightWidth), (0, _setBorderWidth.setBorderBottom)(node.style.borderBottomWidth), (0, _setBorderWidth.setBorderLeft)(node.style.borderLeftWidth), (0, _setDisplay.default)(node.style.display), (0, _setFlexDirection.default)(node.style.flexDirection), (0, _setAlignSelf.default)(node.style.alignSelf), (0, _setAlignContent.default)(node.style.alignContent), (0, _setAlignItems.default)(node.style.alignItems), (0, _setJustifyContent.default)(node.style.justifyContent), (0, _setFlexWrap.default)(node.style.flexWrap), (0, _setOverflow.default)(node.style.overflow), (0, _setAspectRatio.default)(node.style.aspectRatio), (0, _setFlexBasis.default)(node.style.flexBasis), (0, _setFlexGrow.default)(node.style.flexGrow), (0, _setFlexShrink.default)(node.style.flexShrink))(node);
});

/**
 * Attaches a node to it's parent yoga node
 * @param {Object} parentNode
 */
var attachYogNodeToParent = function attachYogNodeToParent(parentNode) {
  return R.tap(function (child) {
    parentNode.insertChild(child[YOGA_NODE], parentNode.getChildCount());
  });
};
var setMeasureFunc = function setMeasureFunc(page, fontStore) {
  return function (node) {
    var yogaNode = node[YOGA_NODE];
    if (isText(node)) {
      yogaNode.setMeasureFunc((0, _measureText.default)(page, node, [], fontStore));
    }
    if (isImage(node)) {
      yogaNode.setMeasureFunc((0, _measureImage.default)(page, node));
    }
    if (isCanvas(node)) {
      yogaNode.setMeasureFunc((0, _measureCanvas.default)(page, node));
    }
    if (isSvg(node)) {
      yogaNode.setMeasureFunc((0, _measureSvg.default)(page, node));
    }
    return node;
  };
};
var isNotText = R.complement(isText);
var isNotNote = R.complement(isNote);
var isNotSvg = R.complement(isSvg);
var isNotTextInstance = R.complement(isTextInstance);
var isLayoutElement = R.allPass([isNotText, isNotNote, isNotSvg]);

/**
 * Creates and add yoga node to document tree
 * Handles measure function for text and image nodes
 *
 * @param {Object} node
 * @returns {Object} node with appended yoga node
 */
var createYogaNodes = function createYogaNodes(page, fontStore, parentNode, rootNode, masks) {
  return function (node) {
    var yogaNode = _rpdfYoga.default.Node.createWithConfig(YOGA_CONFIG);
    return R.compose(R.tap(function (element) {
      var _element$props;
      if (isText(element) && element.lines.length) {
        var _element$lines;
        var position = (0, _getAbsolutePosition.default)(element);
        var dimension = (0, _getDimension.default)(element);
        var maskRects = [];
        // check for collision
        masks.forEach(function (mask) {
          if (mask.absTop + mask.height > position.absTop && position.absTop + dimension.height >= mask.absTop) {
            // there is a vertical collision
            // check for horizontal collision
            if (mask.absLeft + mask.width >= position.absLeft && position.absLeft + dimension.width >= mask.absLeft) {
              // console.error('There is a collision', mask, element);
              maskRects.push({
                y: mask.absTop - position.absTop,
                x: mask.absLeft - position.absLeft,
                width: mask.width,
                height: mask.height
              });
            }
          }
        });
        if (maskRects.length && (_element$lines = element.lines) !== null && _element$lines !== void 0 && _element$lines.length) {
          yogaNode.setMeasureFunc((0, _measureText.default)(page, element, maskRects, fontStore));
          yogaNode.markDirty();
          rootNode.calculateLayout();
        }
      }
      if (isView(element) && (_element$props = element.props) !== null && _element$props !== void 0 && _element$props.fillPreviousWrapTextSpacing) {
        var _position = (0, _getAbsolutePosition.default)(element);
        var _dimension = (0, _getDimension.default)(element);
        var fillNeeded = 0;
        // check for collision
        masks.forEach(function (mask) {
          if (mask.absTop + mask.height > _position.absTop && _position.absTop + _dimension.height >= mask.absTop) {
            // there is a vertical collision
            fillNeeded = Math.max(fillNeeded, mask.absTop + mask.height - _position.absTop);
          }
        });
        if (fillNeeded) {
          // console.log('Fill needed', fillNeeded);
          yogaNode.setMeasureFunc((0, _measureSpaceFillingView.default)(fillNeeded));
          yogaNode.markDirty();
          rootNode.calculateLayout();
        }
      }
    }), R.tap(function (element) {
      if (rootNode) {
        var _element$props2;
        // if the element is a sub-element, re-calculate the layout after adding the yoga node
        rootNode.calculateLayout();
        if ((_element$props2 = element.props) !== null && _element$props2 !== void 0 && _element$props2.wrapTextAround) {
          // calculate the absolute position and add it to masks
          var position = (0, _getAbsolutePosition.default)(element);
          var dimension = (0, _getDimension.default)(element);
          masks.push((0, _extends2.default)({}, position, dimension));
        }
      }
    }), R.when(isLayoutElement, R.evolve({
      children: R.map(R.compose(createYogaNodes(page, fontStore, yogaNode, rootNode || yogaNode, masks)))
    })), R.when(function () {
      return !!parentNode;
    }, attachYogNodeToParent(parentNode)), setMeasureFunc(page, fontStore), setYogaValues, R.assoc(YOGA_NODE, yogaNode))(node);
  };
};

/**
 * Saves Yoga layout result into 'box' attribute of node
 *
 * @param {Object} node
 * @returns {Object} node with box data
 */
var persistDimensions = function persistDimensions(node) {
  return R.evolve({
    children: R.map(R.when(isNotTextInstance, persistDimensions)),
    box: R.always(R.mergeAll([(0, _getPadding.default)(node), (0, _getMargin.default)(node), (0, _getBorderWidth.default)(node), (0, _getPosition.default)(node), (0, _getDimension.default)(node)]))
  })(node);
};

/**
 * Removes yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */
var destroyYogaNodes = function destroyYogaNodes(node) {
  return R.compose(R.dissoc(YOGA_NODE), R.evolve({
    children: R.map(destroyYogaNodes)
  }))(node);
};

/**
 * Free yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */
var freeYogaNodes = function freeYogaNodes(node) {
  if (node[YOGA_NODE]) node[YOGA_NODE].freeRecursive();
  return node;
};

/**
 * Performs yoga calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */
var calculateLayout = function calculateLayout(page) {
  page[YOGA_NODE].calculateLayout();
  return page;
};

/**
 * Calculates page object layout using Yoga.
 * Takes node values from 'box' and 'style' attributes, and persist them back into 'box'
 * Destroy yoga values at the end.
 *
 * @param {Object} page object
 * @returns {Object} page object with correct 'box' layout attributes
 */
var resolvePageDimensions = exports.resolvePageDimensions = function resolvePageDimensions(page, fontStore) {
  return R.ifElse(R.isNil, R.always(null), R.compose(destroyYogaNodes, freeYogaNodes, persistDimensions, calculateLayout, createYogaNodes(page, fontStore, null, null, [])))(page);
};

/**
 * Calculates root object layout using Yoga.
 *
 * @param {Object} root object
 * @returns {Object} root object with correct 'box' layout attributes
 */
var resolveDimensions = function resolveDimensions(node, fontStore) {
  var mapChild = function mapChild(child) {
    return resolvePageDimensions(child, fontStore);
  };
  return R.evolve({
    children: R.map(mapChild)
  })(node);
};
var _default = exports.default = resolveDimensions;